import "./App.css";

function App() {
  return (
    <div className="app-shell">
      <header className="hero">
        <p className="eyebrow">McMahon Studio · Art & Photography</p>
        <h1>Discover the Beauty of Visual Art</h1>
        <p className="lede">
          Welcome to McMahon Studio, where creativity meets passion. Explore our stunning portfolio of photography and visual art that captures the essence of life and emotion.
        </p>
        <div className="cta-row">
          <a href="#portfolio" className="primary">
            View Our Portfolio
          </a>
          <a href="#about" className="secondary">
            Learn More About Us
          </a>
        </div>
      </header>

      <section className="cards">
        <article>
          <h2>Captivating Photography</h2>
          <p>
            Experience the world through our lens. Our photography showcases breathtaking landscapes, intimate portraits, and vibrant moments that tell a story.
          </p>
        </article>
        <article>
          <h2>Visual Art Mastery</h2>
          <p>
            Dive into our collection of visual art that blends imagination with technique. Each piece is crafted to inspire and provoke thought.
          </p>
        </article>
        <article>
          <h2>Connect with Us</h2>
          <p>
            Join our community of art lovers. Follow us on social media and stay updated on our latest works, exhibitions, and events.
          </p>
        </article>
      </section>
    </div>
  );
}

export default App;